const newsPressSection = $('#press-section');
const newsPressCards = newsPressSection.find('.press-card');

const addNewsPressAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const newsPressBtn = newsPressSection.find('.button-parent')

  const newsPressTL = gsap.timeline({
    paused: true,
  });

  if (isDesktop()) {
    newsPressTL.add(
      animateSectionTopperIn({
        sectionParent: newsPressSection,
        gradientConfig: gradientConfig,
      }).play(),
      0
    );
  }

  newsPressTL.add(elementInAnimationYWOpacity(newsPressCards, '36%', 0, 1, 1, 1, 0, 0.2, 'start', 'pageInEasing', 'pageInEasing').play(), 0.3);
  addBtnAnimation(newsPressBtn, 50, true);

  return newsPressTL;
}

const initNewsPressSection = () => {
  const newsPressTL = addNewsPressAnimation();
  ScrollTrigger.create({
    trigger: newsPressSection,
    start: 'top top+=110%',
    end: 'bottom bottom',
    once: true,
    onUpdate: (self) => {
      newsPressTL.progress(self.progress);
    },
  });
}

addSectionObserver(newsPressSection, initNewsPressSection, false);